import React from 'react'
import Bredcom from '../Bredcrumb/Main'
import Book from '../../components/Menhome/Book'


function Main() {
  return (
    <>
      <Bredcom
        subtitle="Reservation"
        title="BOOK YOUR TABLE"
      />
      
      <Book />
    </>
  )
}

export default Main